import { mapProps } from 'recompose';

export const takeEmotesbarStore = mapProps(({state, classes}) => {
  return {
    emotesBar: state.emotesBar,
    classes,
  };
});



// WEBPACK FOOTER //
// ./src/app/components/emotesBar/enhancers.js